import { apiService } from '../api/api-client';
import type { MarkToMarketItem } from '@/types';

/** GET /positions/{id}/marks/ — full MTM history for one position, newest-first. */
export const marksService = {
  async getPositionMarks(positionId: number): Promise<MarkToMarketItem[]> {
    return apiService.get<MarkToMarketItem[]>(`/positions/${positionId}/marks/`);
  },
};
